// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qKPe","top":"styles_top__261jY"};